import { useSelector } from 'react-redux';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import MainLayout from './layout/Main';
import PrivateRoutes from './routes/PrivateRoutes';
import { Login } from './pages/Auth/Login';
// import { useLazyGetMachinesQuery } from './redux/api/machines';
import { useEffect } from 'react';
import TabletLayout from './layout/Tablet';
import TabletRoutes from './routes/TabletRoutes';
import EmbedLayout from './layout/Embed';
import EmbedRoutes from './routes/EmbedRoutes';
import AdminRoutes from './routes/AdminRoutes.tsx';
import { BuildingProvider } from './context/BuildingContext';
import { PrintLocationProvider } from './context/PrintLocationContext';
import { loginPathFor } from './utils/nextPath';
// import { setAuthToken } from './redux/slices/user';

type RootState = {
	user: {
		authToken: string;
	};
};

// Declared at module scope: a component defined inside App would be a new type
// on every render, remounting the whole tree under it.
function CheckAuth({ children }: { children: JSX.Element }): JSX.Element | null {
	const authToken = useSelector((state: RootState) => state.user.authToken);
	const location = useLocation();

	// The login route renders from the second <Routes> below. Redirecting here
	// as well would strip the `next` parameter back off the URL.
	if (location.pathname === '/login') {
		return null;
	}

	// Signing out drops the token, and this is what carries the reviewer back
	// to the page they were on once they sign in again.
	if (!authToken) {
		return (
			<Navigate to={loginPathFor(location.pathname + location.search)} replace />
		);
	}

	return children;
}

function App() {
	const user = useSelector((state: RootState) => state.user);
	// const dispatch = useDispatch();
	// const [getMachines] = useLazyGetMachinesQuery();

	async function ReviewTokenAuth() {
		try {
			// const data: any = await getMachines({});
			// if (data.error?.status == 401) {
			// 	dispatch(setAuthToken(''));
			// }
		} catch (error) {
			console.log(error, 'el error');
		}
	}

	useEffect(() => {
		ReviewTokenAuth();
	}, [user]);

	return (
		<>
			<CheckAuth>
				<BuildingProvider>
					<PrintLocationProvider>
						<Routes>
							<Route
								path="/embed/*"
								element={
									<EmbedLayout>
										<EmbedRoutes />
									</EmbedLayout>
								}
							/>
							<Route
								path="/tablet/*"
								element={
									<TabletLayout>
										<TabletRoutes />
									</TabletLayout>
								}
							/>
							<Route
								path="*"
								element={
									<MainLayout>
										<PrivateRoutes />
									</MainLayout>
								}
							/>
						</Routes>
					</PrintLocationProvider>
				</BuildingProvider>
			</CheckAuth>

			<Routes>
				<Route path="/login" element={<Login />} />
			</Routes>
		</>
	);
}

export default App;
